module.exports = __webpack_public_path__ + "static/api_bg-a8873a64ccaedd4a3caec4ec4a42c1fb.png";